import { useContext } from 'react'
import { useBloc } from './bloc'

import {
  AuthContext,
  type AuthContextData,
  type AuthProviderProps,
} from './types'

export function AuthProvider({ children }: AuthProviderProps): JSX.Element {
  const estadoAutenticacao = useBloc()

  return (
    <AuthContext.Provider value={estadoAutenticacao}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth(): AuthContextData {
  const context = useContext(AuthContext)

  return context
}
